const storageName = 'uw-arukikata-links'

const saveClicked = (isMain=false) => {
  const selector = isMain ? '.link a.btn.page, .link .btn.site, .link .btn.pdf' : '.link_list li a'
  const targets =  document.querySelectorAll(selector)
  Array.from(targets).forEach(target => {
    target.addEventListener('click', (e) => {
      const linksString = localStorage.getItem(storageName)
      const links = linksString === null ? [] : linksString.split(',')

      target.classList.add('done')
      const link = target.href.split('?')[0]
      if(!links.includes(link)){
        links.push(link)
        localStorage.setItem(storageName, links.join(','))
      }
    })
  })
}

const saveVisited = () => {
  const link = location.href
  const linksString = localStorage.getItem(storageName)
  const links = linksString === null ? [] : linksString.split(',')
  if(!links.includes(link)){
    links.push(link)
    localStorage.setItem(storageName, links.join(','))
  }
}

const loadVisited = (isMain=false) => {
  const linksString = localStorage.getItem(storageName)
  const links = linksString === null ? [] : linksString.split(',')

  const selector = isMain ? '.link a.btn.page, .link .btn.site, .link .btn.pdf' : '.link_list li a'
  Array.from(document.querySelectorAll(selector)).forEach(a => {
    if(links.includes(a.href)){
      a.classList.add('done')
      if(isMain && a.classList.contains('page')){
        a.textContent = '読んだ'
      }
    }
  })
}

export { saveClicked, loadVisited, saveVisited }
